import { handleActions } from 'redux-actions'

import * as rawActions from '../../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.changeGalleryDisplayAddVideoDialog](state, action) {
      return action.payload
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
